<template>
  <component :is="modalComponent" ref="modalRef" v-bind="modal.props" :is-visible="isVisible" />
</template>

<script>
import { computed, ref, toRef, watch } from 'vue-demi';

export default {
  props: {
    modal: {
      type: Object,
      required: true,
      validator: (modal) => modal.name,
    },
  },
  setup(props) {
    // Converting to ref ensures the computed will work
    const modal = toRef(props, 'modal');
    const modalRef = ref(null);
    // isVisible is required to trigger the transitions.
    // This need to be controlled for the route-based modals served through the iframe
    const isVisible = ref(false);

    const modalComponent = computed(
      () => () => import(`@/views/modals/${modal.value.name}/${modal.value.name}.vue`),
    );

    // Weird hack that works to show the transition on the modal
    const stop = watch(modalRef, () => {
      isVisible.value = true;
      stop();
    });

    return {
      isVisible,
      modalRef,
      modalComponent,
    };
  },
};
</script>
